export function usePaginationCanonical(page: number, overridePath?: string) {
  const route = useRoute()

  const path = overridePath || route.path

  const canonicalUrl = computed(() => {
    const base = getCanonicalLink(path)
    if (page <= 1) return base
    return `${base}?page=${page}`
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: canonicalUrl.value
      }
    ]
  })
}
